// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { AuthProvider } from "react-oidc-context";
import { register } from './serviceWorkerRegistration';
const R_URI = process.env.REACT_APP_AUTH_DOMAIN;
const cognitoAuthConfig = {
  authority:
    "https://cognito-idp.ap-south-1.amazonaws.com/ap-south-1_568k9cBDa",
  client_id: "1a39ivjo9rt6lqngrp085egiqp",
  redirect_uri: R_URI,
  response_type: "code",
  scope: "aws.cognito.signin.user.admin email openid phone",
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);
// Call the register function directly
register();